import { useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import AppContext from "./Context/Context";
import NavigateURL from "./NavigateURL";
import { useState, useEffect } from "react";

export default function RequireAuth({ children }) {
  const location = useLocation();
  let completeURL = location.pathname + location.search;
  const [IsUserLoggedIn, setIsUserLoggedIn] = useState(true);
  useEffect(() => {
    (async () => {
      if ((await AppContext.IsUserLoggedIn()) === true) {
        let havePermission = await AppContext.CheckAccessAndSettingsBP(completeURL);
        if (havePermission) {
          setIsUserLoggedIn(true);
        } else {
          setIsUserLoggedIn(false);
        }

      } else {
        setIsUserLoggedIn(false);
      }
    })();

    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  return IsUserLoggedIn === true ? children : <NavigateURL />;
}

